import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import BZAPIService from '../../services/BZAPIService';

const DeleteProjectModal = ({ isOpen, toggle, project, projects, setProjects }) => {
  const [newComment, setNewComment] = useState('');

  const handleRemoveProject = async () => {
    const { id } = project;
    await BZAPIService.bsaDeleteProject(id);
    setProjects(projects.filter(p => p.id !== project.id));
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Delete project {project.name}</ModalHeader>
      <ModalBody>
        <p>Are you sure you want to delete this project?</p>
      </ModalBody>
      <ModalFooter>
        <Button className="btn btn-falcon-default btn-sm" onClick={handleRemoveProject}>
          Delete project
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

DeleteProjectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  setProjects: PropTypes.func.isRequired
};

export default DeleteProjectModal;
